<template>
  <header id="upper" ref="headerBar" :inert="$store.state.showWelcome">
    <div
      id="upper-bar"
      v-if="$store.getters.currentUser && $store.getters.currentEdition"
    >
      <div class="header scrollable" :class="{ loaded: loaded }">
        <div class="header-nav" ref="headerNav">
          <div class="nav-links">
            <div class="nav-wrap">
              <router-link to="/welcome" class="nav-link scrollable-logo">
                <img class="header-logo"
                  :src="logoImage"
                  :alt="$store.getters.currentEdition.name + 'logo'"
                />
              </router-link>
              <nav id="header-links" aria-label="Main">
                <router-link
                  v-if="
                    showNavigation && showHomePage
                  "
                  to="/home"
                  class="nav-link"
                  >{{ $t("message.home") }}</router-link
                >
                <router-link
                  to="/programs"
                  class="nav-link"
                  v-if="showNavigation"
                  >{{ $t("message.programs") }}</router-link
                >
                <router-link
                  to="/resource-library"
                  v-if="
                    $store.getters.currentEdition.enable_resource_library &&
                      showNavigation
                  "
                  class="nav-link"
                  >{{ $t("message.resources") }}
                  <span class="count" v-if="newResourceCount">{{
                    newResourceCount
                  }}</span>
                </router-link>
                <router-link
                  :to="communityRoute"
                  class="nav-link"
                  v-if="
                    $store.getters.currentEdition.enable_community &&
                      showNavigation
                  "
                >
                  <span>{{ communityTitle }}</span>
                  <span class="count" v-if="newPostCount">{{
                    newPostCount
                  }}</span></router-link
                >
                <a
                  href=""
                  @click.prevent="openMenu('more', $event)"
                  class="nav-link open-more"
                  v-if="showNavigation"
                  >{{ $t("message.more") }}</a
                >
                </nav>
              </div>
          </div>
          <div class="nav-icons">
            <tooltip :text="$t('message.notifications')">
              <a
                href=""
                @click.prevent="openMenu('notifications', $event)"
                class="nav-icon align-menu-right open-notifications"
                :aria-label="$t('message.notifications')"
                v-if="showNavigation"
              >
                <span class="count" v-if="notificationCount">{{
                  notificationCount
                }}</span>
              </a>
            </tooltip>
            <div
              v-if="showAdminAnalytics"
              class="nav-icon admin-jump non-mobile"
            >
              <tooltip
                :text="$t('message.admin-dashboard')"
                v-if="showAdmin && showNavigation"
              >
                <a
                  href="/auth/open_admin"
                  class="nav-icon"
                  :alt="$t('message.admin-dashboard')"
                  :aria-label="$t('message.admin-dashboard')"
                >
                  <span hidden>{{$t("message.admin-dashboard")}}</span>
                  <admin-dashboard-icon></admin-dashboard-icon>
                </a>
              </tooltip>
              <tooltip
                :text="$t('message.analytics')"
                v-if="showAnalytics && showNavigation"
              >
                <a
                  href="/auth/open_admin"
                  class="nav-icon"
                  :alt="$t('message.analytics')"
                >
                  <span hidden>{{$t("message.analytics")}}</span>
                  <analytics-icon></analytics-icon>
                </a>
              </tooltip>
            </div>
            <tooltip
              :text="$t('message.journeys')"
              v-if="showJourneyButton && showNavigation"
            >
              <button
                class="nav-icon open-journeys"
                @click="handleJourneyClick"
                @keyup.enter="handleJourneyClick"
                :alt="$t('message.journeys')"
                :aria-label="$t('message.journeys')"
              >
                <span hidden>{{$t("message.journeys")}}</span>
                <span class="count" v-if="currentJourneysCount">{{
                  currentJourneysCount
                }}</span>
              </button>
            </tooltip>
            <tooltip :text="$t('message.profile')">
              <a
                href=""
                @click.prevent="openMenu('profile', $event)"
                class="nav-icon account align-menu-right open-profile"
              >
                <img
                  :src="avatarImage"
                  :alt="$t('message.profile')"
                />
                <span hidden>{{$t("message.profile")}}</span>
                <span class="img-shadow"></span>
                <span class="dropdown-caret"></span>
              </a>
            </tooltip>
          </div>
        </div>
      </div>
    </div>
    <NotificationPopups
    v-if="showNavigation && $store.getters.userPopups"
    :notifications="$store.getters.userPopups"
    ></NotificationPopups>
  </header>
</template>


<style>
.ftscroller_container,
.ftscroller_x {
  overflow: visible;
}

</style>

<style lang="less" scoped>
#header-links {
  display: inline-block;
}

.nav-icon {
  outline-offset: 3px;
  border-radius: 100px;
}

@media (prefers-contrast: more) {
  .nav-icon {
    outline: 1px solid white;
    outline-offset: 0;
  }

  .nav-icon:focus {
    outline: 4px solid white;
    outline-offset: 3px;
  }
}

.nav-link,
.nav-icon,
.header-logo {
  -webkit-user-drag: none;
}

.count {
  display: block;
  position: absolute;
  top: -2px;
  right: -4px;
  font-size: 14px;
  line-height: 18px;
  color: white;
  background: #f51a59;
  border-radius: 999px;
  padding: 0 5px;
  font-weight: normal;
  min-width: 18px;
  text-align: center;
}

.open-journeys {
  border-radius: 999px;
  background-color: gray;
  background-image: url(../../assets/journeys-platform-icon.gif);
  background-size: 100% 100%;
  height: 52px;
  cursor: pointer;
  width: 52px;
  .count {
    top: 0px;
  }
}
</style>

<script>
import { mapGetters, mapState } from "vuex";
import $ from "jquery";
import FTScroller from "ftscroller";
import AnalyticsIcon from "./../../assets/analytics-icon.vue";
import AdminDashboardIcon from "./../../assets/admin-dashboard-icon.vue";
import Tooltip from "@/common/components/Tooltip";
import NotificationPopups from "@/common/components/NotificationPopups";

export default {
  data() {
    return {
      loaded: false,
      topScroller: null,
      currentJourneysCount: null,
    };
  },
  mounted() {
    // set up swipable navigation bar
    let $containerElement = $(".header").first();

    let $headerNav = $($containerElement.find(".header-nav")[0]);
    let navWidth = this.calculateNavWidth($headerNav);

    this.topScroller = FTScroller.FTScroller($containerElement.get(0), {
      scrollingY: false,
      contentWidth: navWidth,
      scrollbars: false,
      alwaysScroll: false,
      updateOnWindowResize: true,
      invertScrollWheel: false,
      bouncing: false
    });

    this.$nextTick(this.centreActiveLink);

    // fit scrollable nav bar
    this.fitNavBar();
    window.addEventListener("resize", this.fitNavBar);

    this.headerObserver = new MutationObserver(this.fitNavBar);
    this.headerObserver.observe(this.$refs.headerNav, {
      childList: true,
      subtree: true
    });

    this.loaded = true;

    this.$store.dispatch("fetchNotificationCount");
    this.currentJourneysCount = this.newJourneysCount;
  },
  destroyed() {
    window.removeEventListener("resize", this.fitNavBar);
    this.headerObserver.disconnect();
  },
  methods: {
    fitNavBar() {
      var $window = $(window);
      var $headerNav = $(".header-nav");
      var navWidth = this.calculateNavWidth($headerNav);
      if ($window.width() < navWidth) {
        $headerNav.css("width", navWidth);
      } else {
        $headerNav.css("width", "");
      }
      if (this.topScroller.updateDimensions) {
        this.topScroller.updateDimensions(navWidth);
      }
      return navWidth;
    },
    calculateNavWidth($headerNav) {
      var navWidth = 5;
      $headerNav.find(".nav-link,.nav-icon").each(function() {
        var itemWidth = $(this).outerWidth(true);
        navWidth += itemWidth + 4; // bit extra for whitespace
      });
      return navWidth;
    },
    centreToMenuElement(element) {
      if (element && this.topScroller) {
        var rect = element.getBoundingClientRect();
        this.topScroller.scrollTo(
          (element.offsetLeft || element.parentElement.offsetLeft) +
            rect.width / 2 -
            window.innerWidth / 2,
          0,
          true
        );
      }
    },
    handleJourneyClick() {
      if (this.currentUser.journeys.length) {
        // If user is enrolled in one or more journeys, navigate to the most recently joined
        this.$store.commit("setSelectedJourney", this.currentUser.journeys[0]);
        this.$store.commit("setShowJourney", true);
      } else {
        this.$store.commit("setShowJourneys", true);
      }
    },
    centreActiveLink() {
      let element = this.$refs.headerBar.getElementsByClassName(
        "nav-link router-link-active"
      )[0];
      if (element) {
        window.setTimeout(() => { this.centreToMenuElement(element) }, 150);
      }
    },
    openMenu(menuName) {
      this.$store.commit("setMenuOpen", menuName);
    }
  },
  computed: {
    showNavigation() {
      return !this.$route.meta.templateProps || !this.$route.meta.templateProps.hideNavigation;
    },
    adminType() {
      // display different icon depending on whether analytics only or full dashboard
      if (this.currentUser.permissions.includes('session_management')) {
        return 'dashboard';
      }
      switch (this.$store.getters.currentUser.admin_level) {
        case "group":
        case "edition_analytics":
        case "subscription_team":
          return "analytics";
      }
      return "dashboard";
    },
    showJourneyButton() {
      return this.currentUser.journeys_visible;
    },
    showAdminAnalytics() {
      return this.$store.getters.currentUser.admin_level;
    },
    showAdmin() {
      return this.adminType === 'dashboard';
    },
    showAnalytics() {
      return this.adminType === 'analytics';
    },
    communityTitle() {
      return this.standAndDeliver
        ? this.standAndDeliver.title
        : this.$t("message.community");
    },
    communityRoute() {
      return this.standAndDeliver || this.currentEdition.community_channels_only
      ? "/community/public-channels"
      : "/community"
    },
    showJourneysCount() {
      // Only show count if user hasn't opened journeys before
      return !this.currentUser.seen_journeys && !this.$store.journeys;
    },
    avatarImage() {
      let key = encodeURIComponent(this.currentUser.image);
      return `https://res.cloudinary.com/nomadic/image/fetch/w_52,h_52,c_fill,f_auto/${key}`;
    },
    logoImage() {
      let key = encodeURIComponent(this.currentEdition.header_logo_url);
      return `https://res.cloudinary.com/nomadic/image/fetch/h_104,f_auto/${key}`;
    },
    showHomePage() {
      return this.homeJourney = sessionStorage.getItem('homeJourney')
        || this.$store.getters.currentUser.home_journey
        || this.$store.getters.currentEdition.enable_home_page;
    },
    ...mapGetters([
      "notificationCount",
      "newResourceCount",
      "newJourneysCount",
      "currentEdition",
      "standAndDeliver",
      "newPostCount",
      "currentUser"
    ]),
    ...mapState(["menuOpen"])
  },
  watch: {
    $route: function() {
      this.$nextTick(this.centreActiveLink);
    },
    menuOpen() {
      if (this.menuOpen) {
        this.centreToMenuElement(
          this.$refs.headerBar.getElementsByClassName(
            "open-" + this.menuOpen
          )[0]
        );
      }
    },
    newJourneysCount(newVal) {
      this.currentJourneysCount = newVal;
    }
  },
  components: {
    AdminDashboardIcon,
    AnalyticsIcon,
    Tooltip,
    NotificationPopups
  }
};
</script>
